import { render, staticRenderFns } from "./TicketsEdit.vue?vue&type=template&id=e0f72d9a"
import script from "./TicketsEdit.vue?vue&type=script&lang=js"
export * from "./TicketsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports